<template>
    <div :class="colors[type]" class="p-4 border-2 rounded-md">
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            default: 'success'
        }
    },
    setup () {
        return {
            colors: {
                success: 'bg-green-100 border-green-300',
                warning: 'bg-yellow-100 border-yellow-300',
                info: 'bg-blue-100 border-blue-300',
                danger: 'bg-red-100 border-red-300'
            }
        }
    }
}
</script>
